/** Shared layout/color tokens for hero Vorgang thread mocks (aligned with prod inbox comments). */
export const HERO_VORGANG_RAIL_WIDTH_PX: number = 210;

export const HERO_VORGANG_BUBBLE_INBOUND_BG: string = "#F4F4F5";
export const HERO_VORGANG_BUBBLE_OUTBOUND_BG: string = "#EEF7F2";
export const HERO_VORGANG_CHANNEL_HEADER_BG: string = "rgba(58,158,107,0.02)";
export const HERO_VORGANG_CHANNEL_HEADER_BORDER: string = "rgba(11,15,25,0.08)";
export const HERO_VORGANG_MUTED_BLOCK_BG: string = "#F4F4F5";
export const HERO_VORGANG_QUOTE_COLOR: string = "rgba(11,15,25,0.55)";
export const HERO_VORGANG_VERLAUF_BTN_BORDER: string = "#E5E7EB";

export const HERO_VORGANG_THREAD_GAP_PX: number = 16;
export const HERO_VORGANG_THREAD_PADDING_X_PX: number = 20;
/** Scroll clearance so the last message stays visible under the floating action row. */
export const HERO_VORGANG_ACTION_FOOTER_CLEARANCE_PX: number = 56;

export const HERO_VORGANG_ACTION_BTN: Readonly<{
  readonly display: "inline-flex";
  readonly alignItems: "center";
  readonly justifyContent: "center";
  readonly height: number;
  readonly padding: string;
  readonly border: string;
  readonly borderRadius: number;
  readonly fontSize: number;
  readonly fontWeight: number;
  readonly color: string;
  readonly background: string;
  readonly cursor: "pointer";
}> = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: 32,
  padding: "0 12px",
  border: `1px solid ${HERO_VORGANG_VERLAUF_BTN_BORDER}`,
  borderRadius: 8,
  fontSize: 11,
  fontWeight: 500,
  color: "rgba(11,15,25,0.80)",
  background: "#fff",
  cursor: "pointer",
};
